/**
 * Numeric Mapbox feature ids (sharp-labels phase, 2026-08-26).
 *
 * WHY: dynamic geojson sources (`dynamic: true`) proved unreliable with
 * STRING feature ids at scale — on a ~30k-feature module grid the RT tiler
 * silently dropped whole and partial strings (owner-reported holes; proven
 * by an A/B with `dynamic: false`, which rendered everything). Labels
 * (~3k features, string ids) never showed holes, so the failure scales with
 * feature count. Numeric ids sidestep the string-id path entirely.
 *
 * cyrb53: a well-distributed 53-bit hash — every output is an exact double
 * (Number.isSafeInteger), and at 30k features the collision odds are ~5e-8.
 * Deterministic, so any code that knows the string key can recompute the id.
 */
export function numericFeatureId(str: string): number {
  let h1 = 0xdeadbeef;
  let h2 = 0x41c6ce57;
  for (let i = 0; i < str.length; i++) {
    const ch = str.charCodeAt(i);
    h1 = Math.imul(h1 ^ ch, 2654435761);
    h2 = Math.imul(h2 ^ ch, 1597334677);
  }
  h1 = Math.imul(h1 ^ (h1 >>> 16), 2246822507) ^ Math.imul(h2 ^ (h2 >>> 13), 3266489909);
  h2 = Math.imul(h2 ^ (h2 >>> 16), 2246822507) ^ Math.imul(h1 ^ (h1 >>> 13), 3266489909);
  return 4294967296 * (2097151 & h2) + (h1 >>> 0);
}
